import type { ConfigService, HostKey } from '@neworg-net/amsuite-core/config';

/** Compatibilita temporanea finche il tar pubblicato di amsuite-core espone requireHostUrl. */
export function requireHostUrl(
  config: Pick<ConfigService, 'envProfile' | 'hostUrl'>,
  key: HostKey,
): string {
  const url = config.hostUrl(key);
  if (!url) {
    throw new Error(`AmSuite host "${key}" is not configured for profile "${config.envProfile}".`);
  }
  return url;
}
